/**
 * finixt-ui's Button, typed as a plain button unless the caller says
 * otherwise.
 *
 * The package's button is untyped, which a form treats as a submit button,
 * so a Cancel or a Delete inside a form submitted it. Every other prop goes
 * through as finixt-ui's.
 */
import { Button as FinixtButton, type ButtonProps as FinixtButtonProps } from './finixt.js';

export type ButtonProps = {
  [K in keyof FinixtButtonProps as undefined extends FinixtButtonProps[K] ? K : never]?:
    | FinixtButtonProps[K]
    | undefined;
} & {
  [K in keyof FinixtButtonProps as undefined extends FinixtButtonProps[K]
    ? never
    : K]: FinixtButtonProps[K];
};

export function Button({ type = 'button', ...rest }: ButtonProps) {
  return <FinixtButton type={type} {...(rest as FinixtButtonProps)} />;
}
